var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('Nav'),_c('div',{staticClass:"nav-padding"}),_c('router-view'),_c('Footer'),_c('ScrollTop'),_c('SnsFixed'),_c('Alert'),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }